import { SvgIcon } from '@mui/material'
import { styled } from '@mui/material/styles'

const small = 'M3 16H6V16.4444L3 19.5556V20H6'
const medium = 'M9 11H13V11.6667L9 16.3333V17H13'
const large = 'M16 6H21V6.88889L16 13.1111V14H21'

const displayName = 'Icon/Sleep'
const styleName = displayName.replace(/\W+/g, '')
const Root = styled(SvgIcon, { name: styleName })({
  fill: 'none',
  '& > path': {
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  },
})

export default props => (
  <Root {...props} viewBox="0 0 24 24">
    <path d={small} />
    <path d={medium} />
    <path d={large} />
  </Root>
)
